import { BadgeBg } from 'components/base/Badge';

export interface Signal {
  id: number;
  name: string;
  code: string;
  type: 'Advertência' | 'Proibição' | 'Obrigação' | 'Emergência' | 'Informação';
  category: 'Segurança' | 'Trânsito' | 'Industrial' | 'Comercial' | 'Pública';
  priority: 'Baixa' | 'Média' | 'Alta' | 'Crítica';
  status: {
    label: 'Ativo' | 'Inativo' | 'Em Manutenção' | 'Aguardando Aprovação';
    type: BadgeBg;
  };
  location: string;
  responsible: string;
  budget: number;
  dimensions: string;
  description: string;
  observations?: string;
  createdAt: string;
  updatedAt: string;
}

export const signals: Signal[] = [
  {
    id: 1,
    name: 'Capacete Obrigatório',
    code: 'SIN-001',
    type: 'Obrigação',
    category: 'Segurança',
    priority: 'Alta',
    status: {
      label: 'Ativo',
      type: 'success'
    },
    location: 'Setor A - Área de Construção',
    responsible: 'João Silva',
    budget: 150,
    dimensions: '30x40',
    description: 'Sinalização obrigatória para uso de capacete de segurança',
    observations: 'Verificar posicionamento mensal',
    createdAt: 'Jan 15, 2024',
    updatedAt: 'Mar 10, 2024'
  },
  {
    id: 2,
    name: 'Proibido Fumar',
    code: 'SIN-002',
    type: 'Proibição',
    category: 'Segurança',
    priority: 'Crítica',
    status: {
      label: 'Ativo',
      type: 'success'
    },
    location: 'Depósito de Materiais',
    responsible: 'Maria Santos',
    budget: 80,
    dimensions: '25x25',
    description: 'Sinalização de proibição para área de materiais inflamáveis',
    createdAt: 'Feb 03, 2024',
    updatedAt: 'Feb 03, 2024'
  },
  {
    id: 3,
    name: 'Saída de Emergência',
    code: 'SIN-003',
    type: 'Emergência',
    category: 'Segurança',
    priority: 'Crítica',
    status: {
      label: 'Em Manutenção',
      type: 'warning'
    },
    location: 'Corredor Principal',
    responsible: 'Pedro Oliveira',
    budget: 200,
    dimensions: '40x20',
    description: 'Sinalização luminosa para saída de emergência',
    observations: 'Lâmpada LED queimada - substituir',
    createdAt: 'Dec 20, 2023',
    updatedAt: 'Mar 15, 2024'
  },
  {
    id: 4,
    name: 'Velocidade Máxima 30km/h',
    code: 'SIN-004',
    type: 'Advertência',
    category: 'Trânsito',
    priority: 'Média',
    status: {
      label: 'Ativo',
      type: 'success'
    },
    location: 'Estacionamento',
    responsible: 'Ana Costa',
    budget: 120,
    dimensions: '60x60',
    description: 'Sinalização de limite de velocidade no estacionamento',
    createdAt: 'Jan 08, 2024',
    updatedAt: 'Jan 08, 2024'
  },
  {
    id: 5,
    name: 'Área Restrita',
    code: 'SIN-005',
    type: 'Proibição',
    category: 'Industrial',
    priority: 'Alta',
    status: {
      label: 'Aguardando Aprovação',
      type: 'primary'
    },
    location: 'Sala de Máquinas',
    responsible: 'Carlos Mendes',
    budget: 180,
    dimensions: '35x50',
    description: 'Sinalização para acesso restrito à sala de equipamentos',
    observations: 'Aguardando aprovação da diretoria',
    createdAt: 'Mar 20, 2024',
    updatedAt: 'Mar 22, 2024'
  },
  {
    id: 6,
    name: 'Óculos de Proteção Obrigatório',
    code: 'SIN-006',
    type: 'Obrigação',
    category: 'Segurança',
    priority: 'Alta',
    status: {
      label: 'Ativo',
      type: 'success'
    },
    location: 'Laboratório',
    responsible: 'Dra. Helena Ferreira',
    budget: 95,
    dimensions: '30x30',
    description: 'Sinalização obrigatória para uso de óculos de proteção',
    createdAt: 'Feb 10, 2024',
    updatedAt: 'Feb 10, 2024'
  },
  {
    id: 7,
    name: 'Informações de Evacuação',
    code: 'SIN-007',
    type: 'Informação',
    category: 'Segurança',
    priority: 'Média',
    status: {
      label: 'Inativo',
      type: 'danger'
    },
    location: 'Hall de Entrada',
    responsible: 'Roberto Lima',
    budget: 250,
    dimensions: '80x60',
    description: 'Planta de evacuação e informações de emergência',
    observations: 'Planta desatualizada - necessita revisão',
    createdAt: 'Nov 15, 2023',
    updatedAt: 'Mar 18, 2024'
  },
  {
    id: 8,
    name: 'Cuidado Piso Molhado',
    code: 'SIN-008',
    type: 'Advertência',
    category: 'Segurança',
    priority: 'Média',
    status: {
      label: 'Ativo',
      type: 'success'
    },
    location: 'Área de Limpeza',
    responsible: 'Lúcia Rodrigues',
    budget: 45,
    dimensions: '25x35',
    description: 'Sinalização móvel para advertir sobre piso molhado',
    createdAt: 'Jan 25, 2024',
    updatedAt: 'Jan 25, 2024'
  }
];
